/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Pure helpers of the v2 Real Estate pages, kept apart from the page
 * components so tests do not load the shell (the navbar pulls in lottie).
 */

import { CalendarPlus, Eye, Globe, House } from "lucide-react";
import { humanize } from "../screens/api";
import { isAustralia } from "../variant";

export const greetingFor = (date = new Date()) => {
  const h = date.getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

/** Portal codes in the country's words (REA -> realestate.com.au). */
export const sourceLabel = (code, pack) =>
  (pack?.listing_portals || []).find((p) => p.code === code)?.label || humanize(code);

/** The activity feed from the listing and its viewings, newest first. Pure. */
export function listingActivity(listing, viewings) {
  const events = [];
  (viewings || []).forEach((v) => {
    const who = v.contact_name || v.lead_name || "A buyer";
    if (v.status === "COMPLETED") {
      events.push({ key: `v${v.id}`, icon: Eye, title: `${isAustralia() ? "Inspection" : "Viewing"} with ${who}`, detail: v.feedback || v.next_step || null, at: v.attended_at || v.scheduled_at });
    } else if (v.status === "SCHEDULED" || v.status === "CONFIRMED") {
      events.push({ key: `v${v.id}`, icon: CalendarPlus, title: `${isAustralia() ? "Inspection" : "Viewing"} booked with ${who}`, detail: v.location || null, at: v.scheduled_at });
    }
  });
  if (listing?.listed_date) {
    const portals = (listing.portals || []).join(", ");
    events.push({ key: "listed", icon: Globe, title: "Listed", detail: portals ? `On ${portals}` : null, at: listing.listed_date });
  }
  if (listing?.created_at) events.push({ key: "created", icon: House, title: "Listing created", detail: null, at: listing.created_at });
  return events.sort((a, b) => String(b.at).localeCompare(String(a.at)));
}

